import { ClientActions, ClientList } from "../../domain/clients";
import clientList from "../config/clientList.json"

export const getClientsByIdCompanyService = {
  async execute(): Promise<ClientList[]> {
    const clients: ClientList[] = clientList;

    return new Promise((resolve) => {
      resolve(
        clients.map((client) => {
          return ClientActions().clientList(
            client.clientId,
            client.company,
          );
        })
      );
    });
  },
};
